module.exports = __webpack_public_path__ + "static/media/logo-sm.c6b02794.png";